import gql from 'graphql-tag';

import recentlyEditedMainDisplayObjectFragment from './recentlyEditedMainDisplayObjectFragment';
import recentlyEditedMainDisplayObjectsGroupedByDokkioTagFragment from './recentlyEditedMainDisplayObjectsGroupedByDokkioTagFragment';
import recentlyEditedMainDisplayObjectsGroupedByIntegrationItemKindFragment from './recentlyEditedMainDisplayObjectsGroupedByIntegrationItemKindFragment';
import recentlyViewedIntegrationFragment from './recentlyViewedIntegrationFragment';
import recentlyViewedIntegrationItemKindFragment from './recentlyViewedIntegrationItemKindFragment';
import recentlyViewedMainDisplayObjectFragment from './recentlyViewedMainDisplayObjectFragment';
import recentlyViewedMainDisplayObjectsGroupedByDokkioLabelFragment from './recentlyViewedMainDisplayObjectsGroupedByDokkioLabelFragment';
import recentlyViewedMainDisplayObjectsGroupedByIntegrationItemKindFragment from './recentlyViewedMainDisplayObjectsGroupedByIntegrationItemKindFragment';
import recentlyViewedObjectFragment from './recentlyViewedObjectFragment';

export const recentObjectsFragment = gql`
  fragment recentObjectsFragment on RecentObjects {
    dokkioClass
    recentlyEditedObjects {
      ...recentlyEditedMainDisplayObjectFragment
    }
    recentlyEditedConversations {
      ...recentlyEditedMainDisplayObjectFragment
    }
    recentlyEditedFiles {
      ...recentlyEditedMainDisplayObjectFragment
    }
    recentlyEditedIntegrationEmails {
      ...recentlyEditedMainDisplayObjectFragment
    }
    recentlyEditedIntegrationThreads {
      ...recentlyEditedMainDisplayObjectFragment
    }
    recentlyEditedWebpages {
      ...recentlyEditedMainDisplayObjectFragment
    }
    recentlyEditedMainDisplayObjectsGroupedByDokkioTag {
      ...recentlyEditedMainDisplayObjectsGroupedByDokkioTagFragment
    }
    recentlyEditedMainDisplayObjectsGroupedByIntegrationItemKind {
      ...recentlyEditedMainDisplayObjectsGroupedByIntegrationItemKindFragment
    }
    recentlyViewedObjects {
      ...recentlyViewedObjectFragment
    }
    recentlyViewedConversations {
      ...recentlyViewedMainDisplayObjectFragment
    }
    recentlyViewedFiles {
      ...recentlyViewedMainDisplayObjectFragment
    }
    recentlyViewedDokkioTags {
      ...recentlyViewedMainDisplayObjectFragment
    }
    recentlyViewedIntegrations {
      ...recentlyViewedIntegrationFragment
    }
    recentlyViewedIntegrationEmails {
      ...recentlyViewedMainDisplayObjectFragment
    }
    recentlyViewedIntegrationThreads {
      ...recentlyViewedMainDisplayObjectFragment
    }
    recentlyViewedIntegrationItemKinds {
      ...recentlyViewedIntegrationItemKindFragment
    }
    recentlyViewedMainDisplayObjectsGroupedByDokkioLabel {
      ...recentlyViewedMainDisplayObjectsGroupedByDokkioLabelFragment
    }
    recentlyViewedMainDisplayObjectsGroupedByIntegrationItemKind {
      ...recentlyViewedMainDisplayObjectsGroupedByIntegrationItemKindFragment
    }
  }
  ${recentlyEditedMainDisplayObjectFragment}
  ${recentlyEditedMainDisplayObjectsGroupedByDokkioTagFragment}
  ${recentlyEditedMainDisplayObjectsGroupedByIntegrationItemKindFragment}
  ${recentlyViewedIntegrationFragment}
  ${recentlyViewedIntegrationItemKindFragment}
  ${recentlyViewedMainDisplayObjectFragment}
  ${recentlyViewedMainDisplayObjectsGroupedByDokkioLabelFragment}
  ${recentlyViewedMainDisplayObjectsGroupedByIntegrationItemKindFragment}
  ${recentlyViewedObjectFragment}
`;
export default recentObjectsFragment;
